<template>
  <div>
    <a-card style="margin:20px">
      <template #title>
        <div class="top-title">
          <div class="left">
            <span>账户管理</span>
            <a-icon type="right"/>
            <span>账户信息</span>
          </div>
        </div>
      </template>
      <template slot="extra">
        <a-button @click="toBack">返回</a-button>
      </template>

      <div class="Accountview">
        <!-- 用户信息区域 -->

        <div class="userinfo">
          <div class="userinfo-title">
            {{ this.userinfo.accountName }}
          </div>
          <a-menu
              v-model="selectedKey"
              style="display: flex; flex-wrap: nowrap; white-space: nowrap; overflow-x: auto; "
              :default-open-keys="openKey"

          >
            <a-menu-item v-for="(item, index) in accountInfoList" :key="index" @click="clickMenuItem($event)"
                         style="flex: none;">
              <a-card style=" width: 300px; height: 150px;border-radius: 8px;padding: 0 8px;"
                      v-if="item.account_class !== '6' || $authority('A2BalanceVisible')"
                      :style="selectedKey == index ? 'border-color:#1890ff' : 'border-color:#e8e8e8'">

                <a-tag :color="tagColor(item.account_class)">{{ tagText(item.account_class) }}</a-tag>

                <span>{{ item.account_no }}</span>
                <a-button type="link" v-if="item.account_class === '7'" @click="loanDetailListSearch()">明细</a-button>
                <div class="box-left">

                </div>
                <div class="box-left alias">
                  <p v-if="!remarkEditing[index]">
                    别名: {{ item.remark }}
                    <a-button icon="edit" type="link" size="small" @click.stop="editRemark(item, index)"></a-button>
                  </p>
                  <p v-if="remarkEditing[index]">
                    别名:
                    <a-input style="width: 150px" ref="remark" :value="item.remark" size="small" @click.stop=""
                             @blur="modRemark(item, index, $event)"/>
                  </p>
                </div>

                <div class="balance-box">
                  <div class="box-left">
                    余额:
                  </div>
                  <Balance :amount="item.cur_balance" style="font-weight: bold; "></Balance>
                  <!-- 提现 -->
                  <withdraw-btn v-if="Number(item.account_class) === 0"
                                :channel-no="form.channel_no" :account-no="item.account_no"
                                @ok="getAccountNum"></withdraw-btn>
                  <guarantee-withdraw-btn
                      v-if="Number(item.account_class) === 2"
                      :account-no-a1="userinfo.accountNo" :account-no-a6="item.account_no" :app-no="form.app_no"
                      :channel-no="form.channel_no"
                      @ok="getAccountNum"
                  ></guarantee-withdraw-btn>
                  <guarantee-deposit-btn
                      v-if="Number(item.account_class) === 2"
                      :account-no-a1="userinfo.accountNo" :account-no-a6="item.account_no" :app-no="form.app_no"
                      :channel-no="form.channel_no"
                      @ok="getAccountNum"
                  ></guarantee-deposit-btn>
                </div>
              </a-card>

            </a-menu-item>
          </a-menu>
        </div>
        <!-- 表格 -->
        <!-- table 区域 -->

        <div class="tablebox">
          <!-- 搜索查询 -->
          <!-- 表格 -->
          <div class="searchbox">
            <div class="lefttime">
              <span>交易时间:</span>
              <a-range-picker v-model.trim="searchtime" valueFormat="YYYY-MM-DD" @change="onChange"/>
              <a-radio-group v-model="datater" @change="dataonChange">
                <a-radio-button :value="1">
                  今天
                </a-radio-button>
                <a-radio-button :value="2">
                  昨天
                </a-radio-button>
                <a-radio-button :value="3">
                  近七天
                </a-radio-button>
                <a-radio-button :value="4">
                  当月
                </a-radio-button>
                <a-radio-button :value="5">
                  上月
                </a-radio-button>
              </a-radio-group>
            </div>

            <div class="right">
              <a-button type="primary" @click="search">
                查询
              </a-button>
              <a-button @click="reset">重置</a-button>
            </div>
          </div>
          <!-- 下载 -->

          <div class="uploadbox">
            <div>
              <a-button type="link" icon="eye" @click="detailPV">统计视图</a-button>
              <a-button type="link" icon="download" @click="returnBillDownload" v-if="$authority('receiptDownload')">
                回单({{(selectedRows.length===1)?1:(data?.length??0)}})
              </a-button>
              <a-button type="link" icon="download" @click="checkBillDownload" v-if="$authority('statementDownload')">
                对账单
              </a-button>
              <a-button type="link" icon="download" @click="Detailexport" v-if="$authority('Detailexport')">
                明细表
              </a-button>
            </div>
          </div>
          <div class="tableBody">
            <a-table :rowKey="(record, index) => `${record.id}`" :columns="columns" :data-source="data" size="small"
                     :scroll="{ x: 1800, y: 500 }"
                     :row-selection="{ selectedRowKeys: selectedRowKeys, hideDefaultSelections: true, onChange: onSelectChange, type: 'radio' }"
                     :customRow="clickrow"
                     :pagination="false">

              <!-- 搜索下拉框插槽 -->
              <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" style="padding: 8px"
              >
                <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`搜索 ${column.title}`" :value="selectedKeys[0]"
                         style="width: 188px; margin-bottom: 8px; display: block;" @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                         @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)"/>
                <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                          @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                  搜索
                </a-button>
                <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                  重置
                </a-button>
              </div>

              <!-- 搜索图标 -->
              <a-icon slot="filterIcon" slot-scope="filtered" type="search" :style="{ color: filtered ? '#108ee9' : undefined }"/>


            </a-table>
          </div>
        </div>

      </div> <!-- 分页部分 -->

    </a-card>
    <a-modal v-model="detailPvVisible" width="1000px" @ok="detailPvVisible=false" :closable="false">
      <a-form layout="inline" >
        <a-form-item size="small" label="区分对方账号"><a-switch v-model="pvAcctNo"></a-switch></a-form-item>
      </a-form>
      <div ref="pvExportArea">
        <a-descriptions :column="3" size="small">
          <a-descriptions-item label="户名">
            {{ form.account_name }}
          </a-descriptions-item>
          <a-descriptions-item label="账号">
            {{ form.account_no }}
          </a-descriptions-item>
          <a-descriptions-item label="时间">
            {{ this.form.start_date }} 至 {{ this.form.end_date }}
          </a-descriptions-item>
        </a-descriptions>
        <a-table :columns="detailPVColumn" :data-source="detailPVData" size="small" :pagination="false"/>
        <a-descriptions :column="3" bordered size="small">
          <a-descriptions-item label="总收入">{{ summaryPVData.dCount }}笔
            <Balance :amount="summaryPVData.dSum" dcflag="d" :inline="true"/>
          </a-descriptions-item>
          <a-descriptions-item label="总支出">{{ summaryPVData.cCount }}笔
            <Balance :amount="summaryPVData.cSum" dcflag="c" :inline="true"/>
          </a-descriptions-item>
        </a-descriptions>
      </div>
      <template slot="footer">
        <a-button type="link" @click="exportPVAsPDF">
          <a-icon type="download"></a-icon>
          下载PDF</a-button>
        <a-button type="link" @click="exportPvDataToExcel">
          <a-icon type="download"></a-icon>
          下载Excel</a-button>
        <a-button @click="detailPvVisible=false">关闭</a-button>
      </template>
    </a-modal>

    <a-modal
        v-model="loanDetailVisible"
        title="放款明细"
        width="85%"
        :bodyStyle="{ height: 'auto', minHeight: '40vh', maxHeight: '80vh', padding: '0' }"
        @ok="loanDetailVisible = false"
        :closable="false">
      <div class="modal-content">
        <div class="search">
          <a-form :model="loanDetailForm" layout="inline">
            <a-form-item label="放款日期">
              <a-date-picker style="width: 200px"
                             v-model.trim="loanDetailForm.loanDate"
                             valueFormat="YYYY-MM-DD"
                             @change="loanDetailListSearch"
                             placeholder="请选择放款日期"/>
            </a-form-item>
            <a-form-item label="状态">
              <a-select v-model="loanDetailForm.repayFlag" style="width: 200px" @change="loanDetailListSearch">
                <a-select-option value="">全部</a-select-option>
                <a-select-option :value="1">已结清</a-select-option>
                <a-select-option :value="0">未结清</a-select-option>

              </a-select>

            </a-form-item>
          </a-form>
        </div>
        <a-table
            :columns="loanDetailColumn"
            :data-source="loanDetailData"
            size="small"
            :pagination="false"
            class="modal-table">
          <template slot="action" slot-scope="text, record">
            <a-button
                type="link"
                size="small"
                @click="detail(record)"
                aria-label="明细"
                icon="unordered-list"/>
            <a-button
                type="link"
                size="small"
                @click="repaymentDetails(record)"

            >还款
            </a-button>
          </template>
        </a-table>
        <LcfsPagination
            :page-no.sync="loanDetailPagination.pageNo"
            :page-size.sync="loanDetailPagination.pageSize"
            :total.sync="loanDetailTotal"
            :fn="loanDetailList"/>
      </div>
      <template slot="footer">
        <a-button type="primary" @click="loanDetailVisible = false">关闭</a-button>
      </template>
    </a-modal>

    <a-modal v-model="repayVisible" width="75%" :bodyStyle="{ height: 'auto', minHeight: '30vh', maxHeight: '70vh' }"
             @ok="repayVisible=false" :closable="false">
      <!--      <a-table :columns="repayColumns" :data-source="repayData" size="small" :pagination="false" :scroll="{ x: '70vh',y: '60vh' }"/>-->

      <a-descriptions title="贷款详情" bordered>
        <!-- 基本信息 -->
        <a-descriptions-item label="贷款类型">
          {{ repayData[0]?.loantp === 'c' ? '信用贷款' : '未知' }}
        </a-descriptions-item>
        <a-descriptions-item label="年利率">
          {{ repayData[0]?.yrintrate }}%
        </a-descriptions-item>
        <a-descriptions-item label="贷款账号">
          {{ repayData[0]?.loanacctno }}
        </a-descriptions-item>
        <a-descriptions-item label="发放日期">
          {{ repayData[0]?.lndngdt }}
        </a-descriptions-item>
        <a-descriptions-item label="还款日期">
          {{ repayData[0]?.rpybldt }}
        </a-descriptions-item>
        <a-descriptions-item label="合同编号">
          {{ repayData[0]?.ctrno }}
        </a-descriptions-item>
        <a-descriptions-item label="发放金额">
          <Balance :alignRight="false" :amount="repayData[0]?.dstrbtintrate"/>
        </a-descriptions-item>
        <a-descriptions-item label="应收利息">
          <Balance :alignRight="false" :amount="repayData[0]?.actintamt"/>
        </a-descriptions-item>
        <!-- 贷款状态和形态 -->
        <a-descriptions-item label="贷款状态">
          <a-tag
              :style="{ color: commonDict.loanStatusConfig[repayData[0]?.loanst]?.color || commonDict.loanStatusConfig.default.color }">
            {{ commonDict.loanStatusConfig[repayData[0]?.loanst]?.label || commonDict.loanStatusConfig.default.label }}
          </a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="已还本金">
          <Balance :alignRight="false" :amount="repayData[0]?.actrepymtpnpamt"/>
        </a-descriptions-item>
        <a-descriptions-item label="已还利息">
          <Balance :alignRight="false" :amount="repayData[0]?.acmclctintamt"/>
        </a-descriptions-item>
        <a-descriptions-item label="还款方式">
          <a-tag
              :style="{ color: commonDict.repaymentMethodConfig[repayData[0]?.repymtmd]?.color ||  commonDict.repaymentMethodConfig.default.color  }">
            {{
              commonDict.repaymentMethodConfig[repayData[0]?.repymtmd]?.label || commonDict.repaymentMethodConfig.default.label
            }}
          </a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="本期应还" :span="3">
          本金：
          <Balance :amount="repayData[0]?.crnrpyblamtb" inline/>
          + 利息：
          <Balance :amount="repayData[0]?.crnrpyblamtl" inline/>
        </a-descriptions-item>
        <a-descriptions-item label="剩余应还" :span="3">

          本金：
          <Balance :amount="repayData[0]?.rmanpnpamt" inline/>
          + 利息：
          <Balance :amount="repayData[0]?.crnrpyblamtl" inline/>
          <a-popover>
            <a-icon type="info-circle"></a-icon>
            <template #content>
              <a-list>
                <a-list-item v-if='repayData[0]?.actintamt'>
                  应收利息
                  <Balance :amount="repayData[0]?.actintamt" inline/>
                </a-list-item>
                <a-list-item v-if='repayData[0]?.intamt'>
                  本金利息
                  <Balance :amount="repayData[0]?.intamt" inline/>
                </a-list-item>
                <a-list-item v-if='repayData[0]?.adlint'>
                  应收复息
                  <Balance :amount="repayData[0]?.adlint" inline/>
                </a-list-item>
                <a-list-item v-if='repayData[0]?.ddcint'>
                  催收利息
                  <Balance :amount="repayData[0]?.ddcint" inline/>
                </a-list-item>
                <a-list-item v-if='repayData[0]?.netint'>
                  催收复利
                  <Balance :amount="repayData[0]?.netint" inline/>
                </a-list-item>
                <a-list-item v-if='repayData[0]?.exprtnint'>
                  待收利息
                  <Balance :amount="repayData[0]?.exprtnint" inline/>
                </a-list-item>
                <a-list-item v-if='repayData[0]?.rpybl0dueint'>
                  待收复利
                  <Balance :amount="repayData[0]?.rpybl0dueint" inline/>
                </a-list-item>
              </a-list>
            </template>
          </a-popover>
        </a-descriptions-item>
      </a-descriptions>

      <template slot="footer">
        <a-button type="primary" @click="repayVisible=false">关闭</a-button>
      </template>
    </a-modal>

    <a-modal v-model="repaymentVisible" width="30%" @cancel="repaymentCancel" :closable="false" title="还款">
      <a-form-model :model="repayment" :label-col="repaymentlabelCol" :wrapper-col="repaymentwrapperCol">


        <a-form-model-item label="账号">
          <a-input v-model="repayment.accountNo" disabled/>
        </a-form-model-item>

        <a-form-model-item label="户名">
          <a-input v-model="repayment.accountName" disabled/>
        </a-form-model-item>

        <a-form-model-item label="贷款账号">
          <a-input v-model="repayment.loanacctno" disabled/>
        </a-form-model-item>


        <a-form-model-item label="合同编号">
          <a-input v-model="repayment.ctrno" disabled/>
        </a-form-model-item>

        <a-form-model-item label="还款金额">
          <input-balance v-model="repayment.repymtcorpus"
                         :max=repayment.repymtcorpusMax
                         max-str='全额'
                         style="width: 300px;"
                         align-left></input-balance>
        </a-form-model-item>
        <a-form-model-item label="验证码">
          <paymentSms :verify-code.sync="repayment.verifyCode"
                      model-no="102006"
                      :mobile="form.mobile"
                      :channel-no="form.channel_no"
                      :account-name="repayment.accountName"
                      :account-no="repayment.accountNo"
                      :pay-amount="repayment.repymtcorpus"
                      :disabled="!smsEnable"

          ></paymentSms>
        </a-form-model-item>

      </a-form-model>

      <template slot="footer">
        <a-button type="primary" @click="repaymentSubmit">
          提交
        </a-button>
        <a-button style="margin-left: 10px;" @click="repaymentCancel">
          取消
        </a-button>
      </template>
    </a-modal>


  </div>
</template>
<script>
import dayjs from 'dayjs'
import Balance from '@/view/components/Balance.vue'
import CountdownBtn from "@/view/components/CountdownBtn.vue";
import {groupBy, asyncPool, retryAsync} from "@/utils/commonMethods";
import Vue from "vue";
import InputBalance from "@/view/components/InputBalance.vue";
import PaymentSms from "@/view/components/PaymentSms.vue";
import WithdrawBtn from "@/view/components/WithdrawBtn.vue";
import GuaranteeWithdrawBtn from "@/view/components/GaranteeWithdrawBtn.vue";
import GuaranteeDepositBtn from "@/view/components/GaranteeDepositBtn.vue";
import {commonDict} from "@/utils/bizDict/commonDict";
import LcfsPagination from "@/view/components/LcfsPagination.vue";
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import { utils, writeFile } from 'xlsx';

// import moment from "moment"

export default {
  components: {
    LcfsPagination,
    GuaranteeDepositBtn,
    GuaranteeWithdrawBtn,
    WithdrawBtn,
    PaymentSms,
    InputBalance,
    CountdownBtn,
    Balance
  },
  data() {
    return {
      selectedKey: [0],
      openKey: [],
      accountInfoList: [],
      userinfo: {},
      bailAccountInfo: {},
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      searchtime: [],
      selectedRowKeys: [],
      selectedRows: [],

      show: true,
      detailPvVisible: false,
      loanDetailVisible: false,
      repayVisible: false,
      repaymentVisible: false,
      datater: 1,// 日期
      form: {
        page: 0,
        channel_no: "", // 渠道编号
        app_no: '',//	应用编号	
        account_no: "",// 账号
        account_name: "",// 账号
        start_date: '',
        end_date: '',
      },
      remarkEditing: [],

      searchText: '',
      searchInput: null,
      searchedColumn: '',

      columns: [
        {
          title: 'No',
          dataIndex: 'No',
          customRender: (text, record, index) => `${index + 1}`,
          align: 'center',
          width: 60,
        },
        {
          title: '流水号',
          dataIndex: 'serial_no',
          align: 'center',
          width: 230,
          ellipsis: true,
        },
        {
          title: '记账日期',
          dataIndex: 'account_date',
          align: 'center',
          width: 120,
        },
        {
          title: '交易类型',
          dataIndex: 'trans_type',
          align: 'center',
          width: 80,

          customRender: (text) => {
            if (Number(text) == 0) {
              return '其他'
            } else if (Number(text) == 1) {
              return '开户'
            } else if (Number(text) == 2) {
              return '修改'
            } else if (Number(text) == 3) {
              return '销户'
            } else if (Number(text) == 4) {
              return '存款'
            } else if (Number(text) == 5) {
              return '取款'
            } else if (Number(text) == 6) {
              return '转入'
            } else if (Number(text) == 7) {
              return '转出'
            } else if (Number(text) == 8) {
              return '撤销'
            } else {
              return text;
            }
          },
        },
        {
          title: '对方户名',
          dataIndex: 'opp_account_name',
          align: 'center',
          width: 200,
          ellipsis: true,
        },
        {
          title: '对方账户',
          dataIndex: 'opp_account_no',
          align: 'center',
          width: 160,
        },
        {
          title: '交易金额',
          dataIndex: 'trans_amount',
          align: 'center',
          customRender: (text, row) => {
            let dcflag = ''
            if (['4', '6'].indexOf(row.trans_type) >= 0) dcflag = "d"
            if (['5', '7'].indexOf(row.trans_type) >= 0) dcflag = "c"
            return <Balance amount={text} dcflag={dcflag}></Balance>
          },
          width: 140,
        },
        {
          title: '交易后余额',
          dataIndex: 'balance',
          align: 'center',
          width: 140,
          customRender: (text) => {
            return <Balance amount={text}></Balance>
          },
        },
        {
          title: '交易时间',
          dataIndex: 'trade_time',
          align: 'center',
          width: 180,
        },
        {
          title: '摘要',
          dataIndex: 'remark',
          align: 'center',
          ellipsis: true,
          // 添加搜索功能配置
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
          },
          onFilter: (value, record) => record.remark && record.remark.toString().toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              setTimeout(() => {
                this.searchInput && this.searchInput.focus();
              }, 0);
            }
          }
        },

      ],
      pvAcctNo: false,

      // 表格数据
      data: [],
      //贷款明细数据
      loanDetailForm: {
        loanDate: '',
        repayFlag: undefined

      },
      loanDetailData: [],
      loanDetailColumn: [
        {
          title: 'No',
          align: 'center', width: 70, fixed: 'left',
          customRender: (text, record, index) =>
              `${Number(this.loanDetailPagination.pageNo - 1) * Number(this.loanDetailPagination.pageSize) + Number(index + 1)}`
        },
        {
          title: '活期钱包',
          dataIndex: 'accountNo',
          align: 'center',
          width: 120,
          ellipsis: true,
        },
        {
          title: '贷款账号',
          dataIndex: 'loanacctno',
          align: 'center',
          width: 200,
          ellipsis: true,
        },
        {
          title: '放款日期',
          dataIndex: 'loanDate',
          align: 'center',
          width: 100,
          ellipsis: true,
        },
        {
          title: '放款金额',
          dataIndex: 'loanAmount',
          align: 'center',
          width: 100,
          customRender: (text) => {
            return <Balance amount={text}/>
          }
        },
        {
          title: '已还本金',
          dataIndex: 'repayAmountBj',
          align: 'center',
          width: 100,
          customRender: (text) => {
            return <Balance amount={text}/>
          }
        },
        {
          title: '已还利息',
          dataIndex: 'repayAmountLx',
          align: 'center',
          width: 100,
          customRender: (text) => {
            return <Balance amount={text}/>
          }
        },
        {
          title: '操作',
          width: 150,
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          scopedSlots: {customRender: 'action'}
        }
      ],
      repayData: [],
      repayColumns: [
        {
          title: 'No',
          align: 'center', width: 70, fixed: 'left',
          customRender: (text, record, index) =>
              `${Number(index + 1)}`
        },
        // {title: '贷款类型', dataIndex: 'loantp', key: 'loantp'},

        // {title: '贷款账号', dataIndex: 'loanacctno', key: 'loanacctno'},
        {
          title: '放款金额',
          dataIndex: 'dstrbtintrate',
          width: 140,
          customRender: (text) => {
            return <Balance amount={text}/>
          }
        },
        {title: '放款日期', dataIndex: 'lndngdt'},
        {title: '还款日', dataIndex: 'rpybldt'},
        {
          title: '本月应还本金',
          width: 140,
          dataIndex: 'crnrpyblamtb',
          customRender: (text) => {
            return <Balance amount={text}/>
          }
        },
        {
          title: '本月应还利息',
          width: 140,
          dataIndex: 'crnrpyblamtl',
          customRender: (text) => {
            return <Balance amount={text}/>
          }
        },
        {
          title: '剩余本金',
          width: 140,
          dataIndex: 'rmanpnpamt',
          customRender: (text) => {
            return <Balance amount={text}/>
          }
        },
        // {title: '待收利息', dataIndex: 'exprtnint', key: 'exprtnint'},
        {
          title: '已还本金',
          width: 140,
          dataIndex: 'actrepymtpnpamt',
          customRender: (text) => {
            return <Balance amount={text}/>
          }
        },
        {
          title: '已还利息',
          width: 140,
          dataIndex: 'acmclctintamt',
          customRender: (text) => {
            return <Balance amount={text}/>
          }
        },
        // {title: '合同编号', dataIndex: 'ctrno', key: 'ctrno'},
        // {title: '币种', dataIndex: 'buyexgccycd', key: 'buyexgccycd'},
        // {title: '年利率', dataIndex: 'yrintrate', key: 'yrintrate'},
        {
          title: '贷款状态',
          dataIndex: 'loanst',
          customRender: (text) => {
            const config = commonDict.loanStatusConfig[text] || commonDict.loanStatusConfig.default;
            return <a-tag color={config.color}>{config.label}</a-tag>
          }
        },
        {
          title: '还款状态',
          dataIndex: 'loantp1',
          customRender: (text) => {
            const config = commonDict.loanFormConfig[text] || commonDict.loanFormConfig.default;
            return <a-tag color={config.color}>{config.label}</a-tag>
          }
        },

        {
          title: '还款方式',
          dataIndex: 'repymtmd',
          customRender: (text) => {
            const config = commonDict.repaymentMethodConfig[text] || commonDict.repaymentMethodConfig.default;
            return <a-tag color={config.color}>{config.label}</a-tag>
          }
        },
        // {title: '还款日期', dataIndex: 'loanexprddt'}
      ],

      total: 0, // 总数
      //贷款明细 分页
      loanDetailTotal: 0, // 总数
      loanDetailPagination: {pageNo: 1, pageSize: 10},


      repaymentlabelCol: {span: 5},
      repaymentwrapperCol: {span: 13},
      repayment: {
        accountNo: '',
        accountName: '',
        verifyCode: '',
        loanacctno: '',
        repymtmd: '',
        ctrno: '',
        repymtcorpus: 0,
        repymtcorpusMax: 0,
      },
    }
  },

  created() {
    // 获取存储的用户信息
    this.userinfo = this.$store.state.Accountmanagementinfo
    this.form.app_no = this.$store.state.Accountmanagementinfo.appNo
    this.form.channel_no = this.$store.state.Accountmanagementinfo.channelNo
    this.form.account_no = this.$store.state.Accountmanagementinfo.accountNo
    this.form.mobile = this.$store.state.Accountmanagementinfo.mobile
    const currentTime = dayjs(); // 获取当前日期
   // const startOfMonth = dayjs().startOf('month'); // 获取本月月初时间
    this.form.start_date = currentTime/*.add(1, 'day')*/.format('YYYY-MM-DD')
    this.form.end_date = currentTime/*.add(1, 'day')*/.format('YYYY-MM-DD')
    this.searchtime[0] = this.form.start_date
    this.searchtime[1] = this.form.end_date
    // 获取账号
    this.getAccountNum()
    // 获取交易详细
    this.search()
  },
  mounted() {
    sessionStorage.setItem('msgInfo', true)
  },

  computed: {
    smsEnable() {
      return Number(this.repayment.repymtcorpus) > 0
    },
    commonDict() {
      return commonDict
    },
    tagColor() {
      return function (type) {
        if (type == '0') {
          return 'green'
        } else if (type == '6') {
          return 'blue'
        } else if (type == '8') {
          return 'blue'
        } else if (type == '7') {
          return 'purple'
        } else if (type == '2') {
          return 'yellow'
        }
      }
    },
    tagText() {
      return function (type) {
        if (type == '0') {
          return '活期A1'
        } else if (type == '6') {
          return '冻结A2'
        } else if (type == '7') {
          return '贷款A3'
        } else if (type == '2') {
          return '保证A6'
        } else if (type == '8') {
          return '分户A7'
        }
      }
    },
    detailPVColumn() {
      return [
        {
          title: '对方户名',
          dataIndex: 'opp_account_name',
          align: 'center',
          width: 200,
          ellipsis: true,
        },
          ...(this.pvAcctNo?[{
          title: '对方账号',
          dataIndex: 'opp_account_no',
          align: 'center',
          width: 200,
          ellipsis: true,
        }]:[]),
        {
          title: '交易备注',
          dataIndex: 'remark',
          align: 'center',
          width: 400,
          ellipsis: true,
        }, {
        title: '交易金额合计',
        dataIndex: '合计#trans_amount',
        align: 'center',
        width: 140,
        customRender: (text, row) => {
          let dcflag = ''
          if (['4', '6'].indexOf(row.trans_type) >= 0) dcflag = "d"
          if (['5', '7'].indexOf(row.trans_type) >= 0) dcflag = "c"
          return <Balance amount={text} dcflag={dcflag}></Balance>
        },
      }
      ]
    },
    detailPVData() {
      const pvData = groupBy(this.data ?? [], ['trans_type', 'remark', 'opp_account_name', ...this.pvAcctNo?['opp_account_no']:[]], {sum: ['trans_amount']})
          .filter(item => item['合计#trans_amount'])
          .sort((b, a) => {
            if (a['trans_type'] === b['trans_type']) return a['合计#trans_amount'] - b['合计#trans_amount']
            else return Number(a['trans_type']) - Number(b['trans_type'])
          })
      return pvData
    },
    summaryPVData() {
      let dCount = 0, dSum = 0, cCount = 0, cSum = 0;
      (this.data ?? []).forEach(item => {
        if (['4', '6'].indexOf(item.trans_type) >= 0) {
          dCount++
          dSum += Number(item.trans_amount)
        } else if (['5', '7'].indexOf(item.trans_type) >= 0) {
          cCount++
          cSum += Number(item.trans_amount)
        }
      });
      return {dCount, dSum, cCount, cSum}
    }
  },
  methods: {
    editRemark(item, index) {
      Vue.set(this.remarkEditing, index, true)
      let that = this
      this.$nextTick(() => {
        let el = that.$refs.remark[0]
        el.focus()
        el.select()
      })
    },
    // 修改备注
    modRemark(item, index, event) {
      const newRemark = event.target.value;
      item.remark = newRemark;
      Vue.set(this.remarkEditing, index, false)
      this.api.modRemarkApi({
        accountNo: item.account_no,
        remark: event.target.value
      })
    },

    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0] || '';
      this.searchedColumn = dataIndex;
    },

    handleReset(clearFilters) {
      clearFilters();
      this.searchText = '';
      this.searchedColumn = '';
    },

    dataonChange($event) {
      //  今天 1 昨天2 近七天 3 当月4 上月5 

      this.$set(this.searchtime, 0, dayjs().format('YYYY-MM-DD')); // 替换数组中的某一项
      if ($event.target.value == 1) {
        this.form.start_date = dayjs().format('YYYY-MM-DD')
        this.form.end_date = dayjs().format('YYYY-MM-DD')
      } else if ($event.target.value == 2) {
        this.form.start_date = dayjs().subtract(1, 'day').format('YYYY-MM-DD')
        this.form.end_date = dayjs().subtract(1, 'day').format('YYYY-MM-DD')
      } else if ($event.target.value == 3) {
        this.form.start_date = dayjs().subtract(7, 'day').format('YYYY-MM-DD')
        this.form.end_date = dayjs()/*.add(1, 'day')*/.format('YYYY-MM-DD')
      } else if ($event.target.value == 4) {
        this.form.start_date = dayjs().startOf('month').format('YYYY-MM-DD')
        this.form.end_date = dayjs()/*.add(1, 'day')*/.format('YYYY-MM-DD')
      } else if ($event.target.value == 5) {
        this.form.start_date = dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
        this.form.end_date = dayjs(this.form.start_date).endOf('month')/*.add(1, 'day')*/.format('YYYY-MM-DD')
      }
      // 开始时间
      this.$set(this.searchtime, 0, this.form.start_date);
      // 结束时间
      this.$set(this.searchtime, 1, this.form.end_date);
      this.getqueryTradeDetail()
    },
    // 获取数据
    async getqueryTradeDetail() {
      this.selectedRows = []
      this.selectedRowKeys = []
      const res = await this.api.queryTradeDetailApi(this.form)
      if (res.code !== 200) {
        this.$message.error(res.info);
        return
      }
      this.total = res.data.total
      this.form.page = res.data.current;
      // this.form.row = res.data.size;

      this.data = res.data.detail_list
    },
    async getAccountNum() {
      const res = await this.api.accountqueryBalancedApi({
        channel_no: this.userinfo.channelNo,
        account_no: this.userinfo.majorAccountNo || this.userinfo.accountNo,
        relation_acct: this.userinfo.accountRelation,
      })
      if (res.code !== 200) {
        return this.$message.error(res.info);
      }
      this.accountInfoList = res.data.detail_list
      this.form.account_name = res.data.account_name
      let keyarr = []
      this.accountInfoList.map((item, index) => {
        keyarr.push(index)
      })
      this.openKey = keyarr
    },
    // 明细导出
    async Detailexport() {
      // accountTradeDetailExportApi
      let data = {
        channel_no: this.userinfo.channelNo,
        app_no: this.userinfo.appNo,
        account_no: this.form.account_no,
        start_date: this.form.start_date,
        end_date: this.form.end_date,
      }
      const res = await this.api.accountTradeDetailExportApi(data)
      this.$uploadfile.ExcelDownload('交易明细', res)
    },


    search() {
      this.getqueryTradeDetail()
    },
    // 时间选择器
    onChange() {
      this.form.start_date = this.searchtime[0]
      // this.form.end_date = this.searchtime[1]
      this.form.end_date = dayjs(this.searchtime[1])/*.add(1, 'day')*/.format('YYYY-MM-DD')
      this.datater = ''
    },
    // 查看客户详情
    Customerdetail() {
      // 个人
      if (Number(this.userinfo.accountProperty) == 1) {
        this.$router.push({
          path: "/cust/personage/addCust",
          query: {
            custnum: this.userinfo.custnum,
            type: 'view'
          }
        })
      }
      // 企业
      if (Number(this.userinfo.accountProperty) == 2) {
        this.$router.push({
          name: 'addEnterprise',
          query: {
            custnum: this.userinfo.custnum,
            type: 'view',
          },
        })
      }


    },
    // 统计视图
    detailPV() {
      this.detailPvVisible = true
    },

    exportPvDataToExcel() {
      if (!this.detailPVData || this.detailPVData.length === 0) {
        this.$message.warning('暂无可导出的流水明细');
        return;
      }

      // 1️⃣ 创建 workbook、worksheet
      const wb = utils.book_new();
      const ws = utils.aoa_to_sheet([]);

      // 2️⃣ 顶部信息（账号、账户）
      const infoRows = [
        [`账号：${this.form.account_no||'-'}` , `账户 ：${this.form.account_name||'-'}`, `时间：${this.form.start_date} ~ ${this.form.end_date}`],
        [] // 空行
      ];
      utils.sheet_add_aoa(ws, infoRows, { origin: 'A1' });

      // 3️⃣ 表头
      const tableHeaders = this.detailPVColumn.map(col => col.title);
      utils.sheet_add_aoa(ws, [tableHeaders], { origin: `A${infoRows.length + 1}` });

      // 4️⃣ 表格数据
      const dataRows = this.detailPVData.map(row =>
          this.detailPVColumn.map(col => {
            const val = row[col.dataIndex];
            if (typeof val === 'number') return val;
            if (typeof val === 'string') return val.trim();
            return val !== undefined && val !== null ? val : '';
          })
      );
      utils.sheet_add_aoa(ws, dataRows, { origin: `A${infoRows.length + 2}` });

      // 5️⃣ 汇总信息（总收入、总支出）
      const summaryRow = [
        [`收入笔数`, `${this.summaryPVData.dCount || 0}`, `收入金额`, `${this.summaryPVData.dSum || 0}`],
        [`支出笔数`, `${this.summaryPVData.cCount || 0}`, `支出金额`, `${this.summaryPVData.cSum || 0}`],
      ];
      utils.sheet_add_aoa(ws, summaryRow, { origin: `A${infoRows.length + dataRows.length + 3}` });

      // 6️⃣ 自动调整列宽
      const colWidths = new Array(tableHeaders.length).fill(0);

      // 合并表头 + 数据 + 汇总行进行宽度计算
      const allRows = [tableHeaders, ...dataRows, summaryRow];

      allRows.forEach(row => {
        row.forEach((cell, i) => {
          // 中文字符按 2 英文字符计算，其他按 1 计算
          const cellWidth = cell ? [...String(cell)].reduce((acc, char) => acc + (char.match(/[\u4e00-\u9fa5]/) ? 2 : 1), 0) : 0;
          if (cellWidth > colWidths[i]) {
            colWidths[i] = cellWidth;
          }
        });
      });

      // 设置列宽
      ws['!cols'] = colWidths.map(width => ({ wch: Math.min(width + 2, 50) })); // 最大限制为 50，防止过宽

      // 7️⃣ 添加到 workbook & 下载
      utils.book_append_sheet(wb, ws, '流水详情');
      const filename = `流水详情-${this.form.account_name || '未命名'}-${new Date().toISOString().slice(0, 10)}.xlsx`;
      writeFile(wb, filename);

      this.$message.success('流水明细已成功导出');
    },



    async exportPVAsPDF() {
      if (!this.detailPvVisible) {
        this.$message.warning('请先打开详情弹窗');
        return;
      }

      this.$message.info('正在生成PDF，请稍候...');

      // 延迟确保渲染完成
      await this.$nextTick();

      const element =this.$refs.pvExportArea;
      if (!element) {
        this.$message.error('未找到导出节点');
        return;
      }

      const pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4',
      });

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 15; // 上下左右留白

      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff'
      });

      const imgData = canvas.toDataURL('image/jpeg', 1.0);
      const imgProps = pdf.getImageProperties(imgData);
      const imgWidth = pageWidth - margin * 2;
      const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

      let position = margin;

      if (imgHeight < pageHeight - margin * 2) {
        // 单页
        pdf.addImage(imgData, 'JPEG', margin, position, imgWidth, imgHeight);
      } else {
        // 多页切割
        let remainingHeight = imgHeight;
        let pageCount = 0;
        const canvasHeight = canvas.height;
        const pageCanvasHeight = ((pageHeight - margin * 2) / imgHeight) * canvasHeight;

        while (remainingHeight > 0) {
          const pageCanvas = document.createElement('canvas');
          pageCanvas.width = canvas.width;
          pageCanvas.height = pageCanvasHeight;
          const ctx = pageCanvas.getContext('2d');

          ctx.fillStyle = '#FFFFFF';
          ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);
          ctx.drawImage(
              canvas,
              0,
              pageCount * pageCanvasHeight,
              canvas.width,
              pageCanvasHeight,
              0,
              0,
              canvas.width,
              pageCanvasHeight
          );

          const pageData = pageCanvas.toDataURL('image/jpeg', 1.0);
          if (pageCount > 0) pdf.addPage();
          pdf.addImage(pageData, 'JPEG', margin, margin, imgWidth, pageHeight - margin * 2);

          remainingHeight -= pageHeight - margin * 2;
          pageCount++;
        }
      }

      pdf.save(`流水详情-${this.form.account_name || '未命名'}-${new Date().toISOString().slice(0, 10)}.pdf`);
      this.$message.success('PDF导出完成');
    },

    async returnBillDownload() {
      if (this.selectedRows && this.selectedRows.length == 1) {
        this.returnSingleBillDownload()

      } else {
        this.returnBatchbilldownload()

      }

    },


    // ✅ 公共方法：获取回单文件 Base64 列表（失败时抛出错误，由调用方处理提示）
    async fetchBillFiles(item) {
      if (!item?.original_serialno) {
        throw new Error(`回单缺少流水号: ${item?.serial_no || 'unknown'}`);
      }

      const payload = {
        id: item.id,
        channel_no: this.userinfo.channelNo,
        app_no: this.userinfo.appNo,
        account_no: this.form.account_no,
        original_serialno: item.original_serialno,
        serial_no: item.serial_no
      };

      const res = await this.api.returnBillDownloadApi(payload);

      if (res.code !== 200) {
        throw new Error(res.info || "下载失败");
      }

      const fileList = res.data?.fileList || [];
      if (fileList.length === 0) {
        throw new Error(`暂无回单信息`);
      }

      return fileList.map(f => f.file_data).filter(Boolean);
    },

  //  批量回单下载（带并发控制 + 自动重试 + 进度反馈）
    async returnBatchbilldownload() {
      if (this.isProcessing) {
        this.$message.warning("正在下载中，请等待当前操作完成！");
        return;
      }

      if (!this.data || this.data.length === 0) {
        this.$message.warning("暂无回单可下载！");
        return;
      }

      this.$confirm({
        title: "批量回单下载",
        content: `即将下载 ${this.data.length} 笔回单，是否继续？`,
        onOk: async () => {
          this.isProcessing = true;
          let successCount = 0;
          let failCount = 0;
          let failDetails = []; // 记录失败的流水号
          const allFiles = [];

          // 进度反馈：每 1.5 秒动态更新 loading 消息（防抖，避免并发竞态）
          const totalCount = this.data.length;
          let hideLoading = this.$message.loading(`正在下载回单（0/${totalCount}）...`, 0);
          const progressTimer = setInterval(() => {
            const completed = successCount + failCount;
            if (completed > 0) {
              // 用 destroy() 同步移除旧消息（无渐出动画），避免新旧两条消息重叠
              this.$message.destroy();
              hideLoading = this.$message.loading(
                  `正在下载回单（${completed}/${totalCount}），已成功 ${successCount} 笔`,
                  0
              );
            }
          }, 1500);
          const startTime = Date.now();

          try {
            // 并发控制：最多同时发送 3 个请求（银行接口限流保护）
            // 自动重试：失败后最多重试 2 次，指数退避（1s → 2s）
            // 让回调返回结果，利用 Promise.all 保持输入顺序
            const results = await asyncPool(3, this.data, async (item) => {
              try {
                const fileData = await retryAsync(
                    () => this.fetchBillFiles(item),
                    2,   // maxRetries
                    1000 // baseDelay ms
                );
                successCount++;
                return { success: true, files: fileData || [] };
              } catch (error) {
                console.error(`回单下载失败 [${item.serial_no}]:`, error.message);
                failCount++;
                failDetails.push(item.serial_no);
                return { success: false, files: [] };
              }
            });

            // 清除进度定时器，同步销毁 loading（无动画，避免与结果消息重叠）
            clearInterval(progressTimer);
            this.$message.destroy();

            // 按原始顺序展平合并
            results.forEach(r => {
              if (r.success && r.files.length > 0) {
                allFiles.push(...r.files);
              }
            });

            if (allFiles.length === 0) {
              this.$message.error("下载失败：所有回单均未获取成功，请稍后重试");
              return;
            }

            // 下载所有成功获取的回单（合并为一个 PDF）
            this.$uploadfile.PDFDownloadMerge(`回单-${this.form.account_no}`, allFiles);

            // 显示最终结果（含耗时）
            const elapsed = Math.round((Date.now() - startTime) / 1000);
            const timeStr = elapsed >= 60
                ? `${Math.floor(elapsed / 60)}分${elapsed % 60}秒`
                : `${elapsed}秒`;
            if (failCount === 0) {
              this.$message.success(`全部下载完成！共 ${allFiles.length} 份回单文件（耗时 ${timeStr}）`);
            } else {
              // 部分失败：具体告知用户
              const failSample = failDetails.slice(0, 3).join('、');
              const failMsg = failCount > 3
                  ? `失败 ${failCount} 笔（如 ${failSample}... 等），受银行接口限流影响`
                  : `失败 ${failCount} 笔（${failSample}），受银行接口限流影响`;
              this.$message.warn(
                  `下载完成！成功 ${successCount} 笔，${failMsg}，请重试失败的部分（耗时 ${timeStr}）`,
                  6
              );
            }
          } catch (error) {
            clearInterval(progressTimer);
            this.$message.destroy();
            console.error("批量下载异常:", error);
            this.$message.error("批量下载过程中发生异常，请稍后重试");
          } finally {
            this.isProcessing = false;
          }
        },
        onCancel() {}
      });
    },

    async returnSingleBillDownload() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning("请先选择一条记录");
        return;
      }

      this.isProcessing = true;
      try {
        const item = this.selectedRows[0];
        const files = await this.fetchBillFiles(item);

        if (files.length === 0) return;

        files.forEach((file, index) => {
          this.$uploadfile.PDFDownload(
              `回单-${item.serial_no}-${item.id}${files.length > 1 ? "-" + (index + 1) : ""}`,
              file,
              false
          );
        });
        this.$message.success("下载成功");
      } catch (error) {
        console.error("单条回单下载失败:", error);
        this.$message.error(error.message || "下载失败，请稍后重试");
      } finally {
        this.isProcessing = false;
      }
    },


    // 对账单下载
    async checkBillDownload() {
      let data = {
        channel_no: this.userinfo.channelNo,
        app_no: this.userinfo.appNo,
        account_no: this.form.account_no,
        start_date: this.form.start_date,
        end_date: this.form.end_date,
      }
      const res = await this.api.checkBillDownloadApi(data)
      if (res.code !== 200) {
        this.$message.error(res.info)
        return
      }
      this.$uploadfile.PDFDownload('对账单下载', res.data.file_data, true)

    },
    reset() {
      this.searchtime = []
      this.form.start_date = ''
      this.form.pageNo = 0
      this.form.end_date = ''
    },
    // 确认提现
    // 修改上一页和下一页为文字链接
    itemRender(current, type, originalElement) {

      if (type === 'prev') {
        return <a>上一页</a>;
      } else if (type === 'next') {
        return <a>下一页</a>;
      }
      return originalElement;
    },
    // pagechange(val) {

    //   this.form.page = val;
    //   this.getcustaccountPage()
    // },
    //选中时触发的回调
    onSelectChange(selectedRowKeys, selectedRows) {


      this.selectedRowKeys = selectedRowKeys
      if (selectedRows.length > 1) {
        //获取选中的数据的key
        var selectNumber = this.selectedRowKeys[1]
        //清空选中的key
        this.selectedRowKeys = []
        //选中的数据的key重新赋值给selectedRowKeys
        this.selectedRowKeys.push(selectNumber)
      }
      //获取选中的数据详细信息
      this.selectedRows = [selectedRows[0]]

    },
    clickrow(record) {
      return {
        on: {
          click: () => {
            let id = record.id.toString();
            if (id === this.selectedRowKeys[0]) {
              this.selectedRowKeys = []
              this.selectedRows = []
            } else {
              this.selectedRowKeys = []
              this.selectedRowKeys.push(id)
              this.selectedRows = [record]
            }
          }
        }
      }
    },
    // 改变当前页的事件函数
    onShowSizeChange(current, pageSize) {

      this.form.row = pageSize;
      this.getcustaccountPage()
    },

    clickMenuItem(item) {
      this.accountInfoList.forEach((obj, ind) => {
        if (item.key === ind) {
          if (this.form.account_no !== obj.account_no) {
            this.form.account_no = obj.account_no
            this.form.page = 0
            this.search()
          }
        }
      })
    },
    async loanDetailListSearch() {
      this.loanDetailPagination.pageNo = 1
      this.loanDetailList()
    },

    async loanDetailList() {

      if (!this.accountInfoList || !Array.isArray(this.accountInfoList)) {
        this.$message.error("账户信息列表未加载");
        return;
      }

      const account = this.accountInfoList.filter((item) => item.account_class === '0');

      if (!account || account.length === 0) {
        this.$message.error("未找到符合条件的账户");
        return;
      }

      try {
        const res = await this.api.collectorderscreditListByAccountNo({
          accountNo: account[0]?.account_no,
          ...this.loanDetailPagination,
          ...this.loanDetailForm
        });
        if (res.code !== 200) {
          this.$message.error(res.info);
          return;
        }
        this.loanDetailData = res.data.records;

        this.loanDetailTotal = res.data.total
        this.loanDetailPagination.pageNo = res.data.current
        this.loanDetailPagination.pageSize = res.data.size

        this.loanDetailVisible = true;
      } catch (error) {
        console.error("API 请求失败:", error);
        this.$message.error("请求失败，请稍后重试");
      }
    },

    detail: async function (record) {
      console.log('detail record', record)
      const res = await this.api.creditmanagercreditRepayQueryV2({
        account_no: record.accountNo,
        loanaccno: record.loanacctno
      });
      if (res.code !== 200) {
        this.$message.error(res.info);
        return;
      }
      console.log("detail res", res)
      this.repayData = res.data.recode_list.filter(item =>
          //loanaccno 不起效暂时前端过滤
          item.loanacctno === record.loanacctno
      );
      this.repayVisible = true;
    },

    repaymentDetails: async function (record) {
      console.log("repayData", record)

      const res = await this.api.creditmanagercreditRepayQueryV2({
        account_no: record.accountNo,
        loanaccno: record.loanacctno
      });
      if (res.code !== 200) {
        this.$message.error(res.info);
        return;
      }
      console.log("detail res", res)

      this.repayData = res.data.recode_list.filter(item =>
          //loanaccno 不起效暂时前端过滤
          item.loanacctno === record.loanacctno
      );

      this.repayment.accountNo = this.$store.state.Accountmanagementinfo.accountNo
      this.repayment.accountName = this.$store.state.Accountmanagementinfo.accountName
      this.repayment.loanacctno = this.repayData[0]?.loanacctno
      this.repayment.repymtmd = '1'
      this.repayment.ctrno = this.repayData[0]?.ctrno
      this.repayment.repymtcorpusMax = (Number(this.repayData[0]?.rmanpnpamt) + Number(this.repayData[0]?.crnrpyblamtl)).toFixed(2)

      console.log("  this.repayment", this.repayment)

      this.repaymentVisible = true


    },

    repaymentSubmit: async function () {
      this.repaymentVisible = true
      console.log("repayData", this.repayment)
      this.repayment.repymtmd = this.repayment.repymtcorpusMax === this.repayment.repymtcorpus ? "1" : "0"

      const res = await this.api.repaymentApi({
        ...this.repayment
      });
      if (res.code !== 200) {
        this.$message.error(res.info)
      }
      if (res.code === 200) {
        this.$message.success(res.info)
        this.repaymentVisible = false
        this.repayVisible = false;
        this.loanDetailList()
      }

    },

    repaymentCancel() {
      this.repaymentVisible = false
      this.repayment = {
        repymtcorpus: 0
      }

    },


    toBack() {
      // 返回列表页
      let toURl = ''
      if (this.userinfo.arrList) {
        // 账户列表页
        toURl = '/wallet/accountlist'
      } else {
        // 账户管理
        toURl = '/wallet/accountmanagement'
      }
      this.$router.push(toURl)
    }
  },
  watch: {
    accountInfoList(val) {
      this.remarkEditing = (val ?? []).map(acct => false)
    }
  }
}
</script>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
</style>
<style lang="less" scoped>
/* 自定义表头样式 */
.ant-table-thead > tr > th {
  background-color: #f2f2f2;
}


.ant-menu-horizontal > .ant-menu-item,
/deep/ .ant-menu-horizontal > .ant-menu-submenu {
  border-bottom: 10px solid transparent;
  transition: color 0
}

.ant-menu-horizontal > .ant-menu-item-selected {
  border-bottom: 2px solid #1890ff;
}

/deep/ .ant-card-body {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.top-title {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .left {
    span {
      &:first-child {
        font-size: 15px;
        font-weight: 700;
      }

      // &:last-child {}
    }
  }

  .right {
    button {
      height: 24px;
    }
  }
}

.Accountview {
  width: 100%;

  .userinfo {
    position: relative;
    width: 100%;
    min-height: 200px;

    .userinfo-title {
      font-size: 16px;
      font-weight: bold;
      color: #262626;
      margin: 0 0 20px 20px;
    }

    .alias {
      p {
        color: grey;
        font-size: 12px;
      }

      button {
        visibility: hidden;
      }
    }

    .alias:hover {
      button {
        visibility: visible;
      }
    }

    .balance-box {
      display: flex;
      align-items: center;
      margin-top: 15px;
      margin-bottom: 15px;

      .box-left {
        margin-right: 35px;
        font-weight: bold;
        color: #262626;
        font-size: 16px;
      }
    }

    .content {
      width: 100%;
      padding: 0 24px;

      .mian {
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 15px;
        width: 100%;
        padding-bottom: 10px;
        min-height: 138px;
        box-shadow: inset 0 0 1px 1px #f2f2f2;

        .toptext {


          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          font-size: 20px;

          .item {
            width: 188px;
            margin-bottom: 25px;

            span {
              &:first-child {
                margin-right: 10px;
              }
            }


            &:nth-child(2) {
              width: 300px;
            }

            &:nth-child(4) {
              width: 200px;
            }
          }
        }

        .Currentbalance {
          display: flex;
          align-items: center;
          font-size: 18px;
          font-weight: 600;
          flex-wrap: wrap;
          justify-content: space-between;
          margin-bottom: 30px;
          padding-right: 60px;

          > div {
            display: flex;
          }

          .Current {
            // width: 300px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            span {
              font-size: 18px;
              font-weight: 700;
              color: #333333;
              margin-right: 10px;

              &:last-child {
                // margin-left: 5px;
                // margin-top: 5px;
                font-weight: 600;
              }
            }
          }

          .usable {
            margin-left: 210px;
            width: 140px;
            display: flex;
            justify-content: space-between;

            span {
              font-size: 18px;
              font-weight: 700;

              &:last-child {
                font-weight: 600;
                margin-top: 5px;
              }
            }
          }

          .Customerdetails {


            button {
              height: 24px;
            }
          }
        }

        .Yesterdaybalance {
          span {
            font-size: 13px;
            color: #aaaaaa;
          }
        }
      }
    }

    .Breadcrab {
      position: absolute;
      bottom: 0px;
      width: 100%;
      height: 35px;
      display: flex;
      padding-left: 24px;
      align-items: center;
      border-bottom: 1px solid #d7d7d7;
      margin-bottom: 10px;
      padding-bottom: 10px;
      justify-content: space-between;
      padding-right: 25px;

      .left {
        span {
          &:first-child {
            font-size: 15px;
            font-weight: 700;
          }

          // &:last-child {}
        }
      }
    }
  }

  .tablebox {
    padding: 0 24px;
    width: 100%;
    height: 100%;
    margin-bottom: 20px;

    .searchbox {
      min-height: 44px;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      padding-top: 15px;


      .lefttime {
        .ant-calendar-picker {
          margin-left: 20px;
          margin-right: 20px;
          width: 200px;
          border-radius: 6px;
          height: 24px !important;
        }
      }

      .right {
        margin-left: 100px;

        button {
          height: 32px;
        }
      }
    }

    .uploadbox {
      display: flex;
      justify-content: flex-end;

      button {
        height: 28px;
      }

      margin-bottom: 20px;
    }
  }

  .paginationBox {
    display: flex;
    justify-content: flex-end;

    // .ant-pagination-options {
    //   float: left;
    // }

    .ant-pagination-prev,
    .ant-pagination-next,
    .ant-pagination-jump-prev,
    .ant-pagination-jump-next {
      border: 1px solid #d9d9d9;
      width: 60px;
    }
  }
}

.ant-modal-footer {
  border: none;
  padding-bottom: 20px;
}

.ant-menu-vertical > .ant-menu-item,
/deep/ .ant-menu-vertical > .ant-menu-submenu {
  height: 170px;
  padding: 10px;
}

.modal-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px; /* 添加一些内边距 */
}

.search {
  margin-bottom: 16px; /* 添加一些间距 */
}

.modal-table {
  flex: 1;
  overflow-y: scroll;
  max-height: 70vh;
}

</style>
